import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import GstEditForm from './GstEditForm';
import GstList from './GstList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import GstListView from './GstListView'


export default function GstDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.gstDashboard);
  const [ gstId, setGstId] = React.useState('');
  const [reloadGstList, setReloadGstList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <GstEditForm 
            setReloadGstList={setReloadGstList}
            gstId={gstId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <GstListView 
                      setGstId = {setGstId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
